import type { FC } from 'react'
import styled from '@emotion/styled'

import Image from '@segment/matcha/components/Image'

import heroPng2x from './assets/Hero@2x.png'
import heroWebp from './assets/Hero.webp'
import heroWebp2x from './assets/Hero@2x.webp'

interface HeroImageProps {
  alt: string
}

const HeroImage: FC<HeroImageProps> = ({ alt }) => {
  return (
    <Picture>
      <source type="image/webp" srcSet={`${heroWebp}, ${heroWebp2x} 2x`} />
      <Image width="528" height="386" src={heroPng2x} alt={alt} loading="lazy" />
    </Picture>
  )
}

const Picture = styled.picture`
  filter: drop-shadow(${({ theme }) => theme.shadows[2]});
`

export default HeroImage
